module.exports = __webpack_public_path__ + "static/img/whatsapp.d335807c.png";